<script>
  export let copy;
</script>

<svelte:head>
  <title>{copy.title}</title>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
  <meta name="description" content="{copy.description}" />
  <meta name="author" content="Google Trends" />
  <meta name="news_keywords" content="Olympics" />

  <meta property="og:title" content="{copy.title}" />
  <meta property="og:site_name" content="Google Trends" />
  <meta property="og:url" content="https://olympics-trends.appspot.com" />
  <meta property="og:description" content="{copy.description}" />
  <meta property="og:type" content="article" />
  <meta property="og:locale" content="en_US" />

  <meta
    property="og:image"
    content="https://olympics-trends.appspot.com/assets/facebook.jpg"
  />
  <meta property="og:image:type" content="image/jpeg" />
  <meta property="og:image:width" content="1200" />
  <meta property="og:image:height" content="600" />

  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:site" content="https://olympics-trends.appspot.com/" />
  <meta name="twitter:creator" content="@GoogleTrends" />
  <meta name="twitter:title" content="{copy.title}" />
  <meta name="twitter:description" content="{copy.description}" />
  <meta
    name="twitter:image:src"
    content="https://olympics-trends.appspot.com/assets/twitter.jpg"
  />

  <meta name="robots" content="max-image-preview:large" />

  <link rel="canonical" href="https://olympics-trends.appspot.com/" />
</svelte:head>
